function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Table, Spinner, Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import Common from "../../components/includes/Common";
import { Skeleton, Button, Form, Input, DatePicker, Modal, Drawer, message, notification, Tag, Space } from 'antd';
import { EyeFill, TrashFill, PenFill, EmojiSmileFill, TicketPerforated } from 'react-bootstrap-icons';
import moment from 'moment';
import AdminAdBox from "../admin-components/AdminAdBox";
import { useParams } from 'react-router-dom';
import EditEvent from "../../components/account/forms/EditEvent";
import EventSummary from "../admin-components/EventSummary";
import AddEvent from "../admin-forms/AddEvent";
import AddContest from "../admin-forms/AddContest";
import ContestSummary from "../admin-components/ContestSummary";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var ContestManagement = function ContestManagement() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    contestList = _useState2[0],
    setContestList = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loadingData = _useState4[0],
    setLoadingData = _useState4[1];
  var _useState5 = useState(300),
    _useState6 = _slicedToArray(_useState5, 2),
    limit = _useState6[0],
    setLimit = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    offset = _useState8[0],
    setOffset = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedContest = _useState10[0],
    setSelectedContest = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    displayEditDrawer = _useState12[0],
    setDisplayEditDrawer = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showManageTicket = _useState14[0],
    setShowManageTicket = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showSummary = _useState16[0],
    setShowSummary = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showEdit = _useState18[0],
    setShowEdit = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showAddNewContest = _useState20[0],
    setShowAddNewContest = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    dataChanged = _useState22[0],
    setDataChanged = _useState22[1];
  var handleManageTickets = function handleManageTickets(e) {
    setSelectedContest(e);
    setShowManageTicket(true);
  };
  var loadContests = function loadContests() {
    setLoadingData(true);
    axios.get(Common.baseApiUrl + 'getcontests/' + limit.toString() + '/' + offset.toString()).then(function (response) {
      setLoadingData(false);
      if (response.data.status == 200) {
        setContestList([]);
        setContestList(response.data.contests);
      }
    })["catch"](function (error) {})["finally"](function () {
      setLoadingData(false);
    });
  };
  useEffect(function () {
    setDataChanged(false);
    loadContests();
  }, [dataChanged]);
  var onFinish = function onFinish(values) {
    var formData = new FormData();
    formData.append('from', values.period[0]._d);
    formData.append('to', values.period[1]._d);
    formData.append('user', Common.currentUser.id);
  };
  var swtichContestActivation = function swtichContestActivation(event, status) {
    var newStatus = status == 1 ? 0 : 1;
    axios.post(Common.baseApiUrl + 'switchconteststatus', {
      id: event.id,
      user_id: Common.currentUser.id,
      status: newStatus
    }).then(function (response) {
      if (response.data.status == 200) {
        message.success({
          content: response.data.message,
          duration: 5,
          key: 1,
          icon: /*#__PURE__*/_jsx(EmojiSmileFill, {
            size: 25
          })
        });
      } else {
        message.error({
          content: response.data.message,
          duration: 5,
          key: 0
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        duration: 5,
        key: 0
      });
    });
  };
  var handleContestDelete = function handleContestDelete(event) {
    setSelectedContest(event);
    Modal.confirm({
      title: 'Confirmation',
      content: 'Supression de ' + event.label + ' ?',
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "/deletecontest", {
          user_id: Common.currentUser.id,
          event_id: event.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.erro({
              message: "Erreur !",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.erreur({
            message: "Erreur!",
            description: "Une erreur est survenue"
          });
        })["finally"](function () {});
      }
    });
  };
  var handleEventActivation = function handleEventActivation(event) {
    setSelectedContest(event);
    var action = event.status == 0 ? 'Activation' : 'Désactivation';
    Modal.confirm({
      title: 'Confirmation',
      content: action + ' de ' + event.label + ' ?',
      onOk: function onOk() {
        swtichContestActivation(event, event.status);
      }
    });
  };
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsxs("div", {
          className: "data-container",
          children: [/*#__PURE__*/_jsx(Tag, {
            color: "#104E7A",
            style: {
              margin: "7px 0px"
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "Gestion des comp\xE9titions"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "admin-filter-box cool-radius white-bg",
            children: /*#__PURE__*/_jsxs(Form, {
              layout: "inline",
              onFinish: onFinish,
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "period",
                label: "Periode",
                children: /*#__PURE__*/_jsx(RangePicker, {
                  ranges: {
                    'Ajourdhui': [moment(), moment()],
                    'Ce Mois-ci': [moment().startOf('month'), moment().endOf('month')]
                  },
                  format: "DD/MM/YYYY HH:mm",
                  showTime: true
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "submit",
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  htmlType: "submit",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "TROUVER"
                  })
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "submit",
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  onClick: function onClick() {
                    setShowAddNewContest(true);
                  },
                  style: {
                    backgroundColor: "#3F637F"
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: "NOUVEAU"
                  })
                })
              })]
            })
          }), contestList.length > 0 ? /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(Container, {
              children: /*#__PURE__*/_jsx(Row, {
                children: /*#__PURE__*/_jsx(Col, {
                  lg: 9,
                  md: 10,
                  children: contestList.map(function (e) {
                    return /*#__PURE__*/_jsx("div", {
                      className: "white-bg feed-box",
                      children: /*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 4,
                          md: 4,
                          sm: 5,
                          xs: 5,
                          children: /*#__PURE__*/_jsx("img", {
                            src: e.cover_url,
                            style: {
                              width: '100%'
                            }
                          })
                        }), /*#__PURE__*/_jsxs(Col, {
                          lg: 8,
                          md: 8,
                          sm: 7,
                          xs: 7,
                          children: [/*#__PURE__*/_jsx("h6", {
                            children: /*#__PURE__*/_jsx("b", {
                              children: e.label
                            })
                          }), /*#__PURE__*/_jsxs(Tag, {
                            color: "#f50",
                            children: [e.contest_milestones.length, " Etapes"]
                          }), /*#__PURE__*/_jsx("p", {
                            children: e.description
                          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Space, {
                            direction: "vertical",
                            children: /*#__PURE__*/_jsxs(Space, {
                              direction: "horizontal",
                              style: {
                                clear: "both"
                              },
                              children: [/*#__PURE__*/_jsxs(Button, {
                                type: "link",
                                href: "/#/az/panel/manage-votes/" + e.id,
                                children: [" ", /*#__PURE__*/_jsx("b", {
                                  children: "VISUALISER"
                                })]
                              }), /*#__PURE__*/_jsxs(Button, {
                                type: "link",
                                onClick: function onClick() {},
                                children: [" ", /*#__PURE__*/_jsx("b", {
                                  children: "AJOUTER UNE ETAPE"
                                })]
                              }), /*#__PURE__*/_jsx(Button, {
                                type: "link",
                                onClick: function onClick() {},
                                children: /*#__PURE__*/_jsx("b", {
                                  children: /*#__PURE__*/_jsx(PenFill, {
                                    size: 16
                                  })
                                })
                              }), /*#__PURE__*/_jsx(Button, {
                                type: "link",
                                onClick: function onClick() {},
                                children: /*#__PURE__*/_jsx("b", {
                                  children: /*#__PURE__*/_jsx(TrashFill, {
                                    size: 16
                                  })
                                })
                              })]
                            })
                          }), /*#__PURE__*/_jsx("br", {})]
                        })]
                      })
                    }, e.id);
                  })
                })
              })
            })
          }) : /*#__PURE__*/_jsx(_Fragment, {
            children: loadingData && /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })]
        })
      })
    }), selectedContest != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        title: "EDITER CONCOURS",
        onClose: function onClose() {
          setDisplayEditDrawer(false);
        },
        visible: displayEditDrawer,
        destroyOnClose: true,
        width: "650",
        children: /*#__PURE__*/_jsx(EditEvent, {
          event: selectedContest,
          handler: function handler() {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Modifications enregistrées !"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: "DETAILS CONCOURS",
        onClose: function onClose() {
          setShowManageTicket(false);
        },
        visible: showManageTicket,
        destroyOnClose: true,
        width: "90%",
        children: /*#__PURE__*/_jsx(ContestSummary, {
          contest: selectedContest,
          refresh: setDataChanged
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: selectedContest.label,
        width: "90%",
        footer: null,
        open: showSummary,
        onCancel: function onCancel() {
          setShowSummary(false);
        },
        children: /*#__PURE__*/_jsx(ContestSummary, {
          contest: selectedContest
        })
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      title: "AJOUTER UN CONCOURS",
      onCancel: function onCancel() {
        setShowAddNewContest(false);
      },
      open: showAddNewContest,
      destroyOnClose: true,
      footer: null,
      width: {
        xs: '95%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '40%'
      },
      children: /*#__PURE__*/_jsx(AddContest, {
        handler: function handler() {
          setShowAddNewContest(false);
          setDataChanged(true);
          notification.success({
            message: "Concours ajouté!",
            description: "Ajoutez des étapes pour continuer"
          });
        }
      })
    })]
  });
};
export default ContestManagement;